import Vue from 'vue';
import batchTransformer from '../../transformers/batch';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(batchTransformer.fetch(errors));
};

export default (id, option) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/batch/transfer_product/${id}/update`, option)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batch/updateBatchTransfer.js